const sortRunsByDate = (order: "asc" | "desc") => (a: { ranAt: string }, b: { ranAt: string }) => {
  const orderFactor = order === "asc" ? 1 : -1
  return orderFactor * (Date.parse(a.ranAt) - Date.parse(b.ranAt))
}

export { sortRunsByDate }
